export enum CandidateDeclarationExports {
	safeguardingQuestionaire = "safeguardingQuestionaire",
	healthRecord = "healthRecord",
	criminalRecord = "criminalRecord",
	contractForService = "contractForService",
	kcsie = "kcsie",
	declaration = "declaration",
	referenceDeclaration = "referenceDeclaration",
	eventLog = "eventLog",
}
